import { render } from "./settingsInput.vue?vue&type=template&id=3585e9ba&bindings={\"keyString\":\"data\",\"enterKeyString\":\"options\",\"isValidSingleKeyString\":\"options\",\"validateKeyString\":\"options\"}"
import script from "./settingsInput.vue?vue&type=script&lang=js"
export * from "./settingsInput.vue?vue&type=script&lang=js"
script.render = render

export default script